import React, { Component } from 'react';
import styled from '@emotion/styled';
import UIWidth from './UIWidth';

const H1 = styled.h1`
  color: ${props =>
    props.color ? props.theme[props.color] : props.theme.lightColor};
  padding: 0.5rem 0.625rem 1rem;
  vertical-align: middle;
  font-size: 1.125em;
  line-height: 1.2em;
  margin: 0;
  font-family: ${props => props.theme.mainFont};
  @media (min-width: ${props => props.theme.tablet}) {
    font-size: ${props => props.fontSize ?? '2.25em'};
    padding: 0 0
      ${props => {
        if (props.paddingBottom0) {
          return '0';
        }
        if (props.paddingBottom) {
          return props.paddingBottom;
        }
        return '10rem';
      }};
  }
  @media print {
    color: inherit;
    padding: 1em 0;
  }
  ${props => props.textAlign && `text-align: ${props.textAlign};`}
`;

class PageTitle extends Component {
  render() {
    return (
      <UIWidth>
        <H1
          textAlign={this.props.textAlign}
          paddingBottom0={this.props.paddingBottom0}
          paddingBottom={this.props.paddingBottom}
          fontSize={this.props.fontSize}
          color={this.props.color}
        >
          {this.props.children}
        </H1>
      </UIWidth>
    );
  }
}

export default PageTitle;
